import { Divider, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useProductStore } from "../../../hooks/useProductStore";
import { CustomSearchProducts } from "../../../components/common/CustomSearchProducts/CustomSearchProducts";
import { useMediaQuery } from '@mui/material';
import '../../../assets/styles/facturacionv3-app.css'
import { readLocalStorage } from "../../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../../types";

const columns = [
    { type: 'text', field: 'code_system', label: 'Código producto', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    // { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
    { type: 'text', field: 'cost', label: 'Costo', align:'center' },
    { type: 'text', field: 'price', label: 'Precio', align:'center' },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align:'center' },
];

const listProducts = []

type Values = {
    id: number,
    name: string,
    validity: string,
    status: string,
}

export const SelectProductsModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, productsSelected, setProductsSelected, setFilter, clearState } = props;

    const { getProductsByCompany, getProducts } = useProductStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [products, setProducts] = useState<any>([]);
    const [selected, setSelected] = useState<any>([...productsSelected]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    const [page, setPage] = useState<number>(1)
    const [perPage, setPerPage] = useState<number>(10)
    const [totalRows, setTotalRows] = useState<number>(0)

    const isSxSmMd = useMediaQuery('(min-width: 900px) and (max-width: 1536px)');

    useEffect(() => {
        getProductsApi()
    },[page, perPage])

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const rutcompany = userData?.rut

    const getProductsApi = async(search='', idcategory='', idsubcategory='', idspecificsubcategory='') => {
        try {
            setLoadingdata(true);
            const response = await getProductsByCompany({search:search, idcategory:idcategory, idsubcategory:idsubcategory, idspecificsubcategory:idspecificsubcategory, page: page, perPage: perPage});
            const newData:any = [];
            response && (response).length > 0 && (response).map((item)=>{
                newData.push({
                    id: item.id,
                    code: item.code,
                    code_system: item.code_system,
                    code_erp: item.code_erp,
                    barcode: item.barcode,
                    name: item.name,
                    description: item.description,
                    cointypesymbol: item.cointypesymbol,
                    cost: item.cost,
                    price: item.price,
                    offerprice: item.offerprice,
                    stock: 0,
                    discount: 0,
                    subtotal: 0,
                    idcompany: item.idcompany,
                })
            })
            setTotalRows(response?.total || 1000)
            setProducts(newData || []);
            setLoadingdata(false);
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = products.map((n) => n);
            setSelected(newSelected);
            setProductsSelected(newSelected);
            setFilter(newSelected);
            return;
        }
        setSelected([]);
    };
    const onCheckbox = (row) => {
        const selectedIndex = selected.findIndex(selectedRow => selectedRow.id === row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
        setProductsSelected(newSelected)
        setFilter(newSelected)
    };
    const isSelected = (row) => {
        return selected.some(item => item.id === row.id);
    };

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getProductsApi(term)}, 1000)
        )
    }

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage + 1)
    }

    const handleChangeRowsPerPage = (event) => {
        setPerPage(+event.target.value)
        setPage(1)
    }

    return (
        <>
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh'}}}>
            <ModalHeader
                text={'Seleccionar productos'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>

                { rutcompany !== "76868240-2" && <CustomSearchProducts setProducts={setProducts} getProductsApi={getProductsApi}/>}

                <Grid container sx={{padding:'0px 20px 20px 20px'}}>
                    <Grid item container xs={12} spacing={2}>
                        <Grid item xs={12}>
                            <CustomTable 
                                disabled_title
                                columns={columns}
                                loading={loadingdata}
                                rows={products || []}
                                onRowClick={() => {}}
                                selectAll={handleSelectAllClick}
                                onCheckbox={onCheckbox}
                                isSelected={isSelected}
                                onSearch={onSearch}
                                RowsPerPage={5}
                                heightTable={420}
                                dense

                                totalRows={totalRows}
                                rowsPerPage={perPage}
                                page={page}
                                handleChangePage={handleChangePage}
                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                                withCustomPagination
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Divider />
            </ModalBody>
        </Modal>
        </>
    )
}